import styled from 'styled-components';
import color from '../../../config/colors.json';
import ScreenSize from '../../../config/screenSizes.json';

export const Title = styled.h1`
    color: ${color.dark};
    font-family: 'Poppins', sans-serif;
    font-size: ${({ titleSize }) => titleSize};
    line-height:  ${({ titleHeight }) => titleHeight};
    margin: 0;
    font-weight: 600;
    margin-top: ${({ titleMarginTop }) => titleMarginTop};
    margin-bottom: ${({ titleMarginBottom }) => titleMarginBottom};
    letter-spacing: ${({ letterSpacing }) => (letterSpacing || '0')};
    @media screen and (max-width: ${ScreenSize.tablet}px) {
        font-size: ${({ fontSize }) => (`calc (${fontSize} - 5px)` || '20px')};
        line-height:  ${({ lineheight }) => (`calc (${lineheight} - 5px)` || '28px')};
    }
`;

export const Subtitle = styled.h2`
    color: ${({ subtitleColor }) => (subtitleColor || color.grey)};
    font-family: 'Poppins', sans-serif;
    font-size: ${({ fontSize }) => (fontSize || '14px')};
    line-height: ${({ lineheight }) => (lineheight || '21px')};
    font-weight: 400;
    margin-bottom: ${({ subtitleMarginBottom }) => (subtitleMarginBottom || '20px')};
    @media screen and (max-width: ${ScreenSize.tablet}px) {
        font-size: ${({ fontSize }) => (`calc (${fontSize} - 5px)` || '15px')};
        line-height:  ${({ lineheight }) => (`calc (${lineheight} - 5px)` || '23px')};
    }
`;
